/* Overcut : bloc "Votre voiture brodée" de la fiche produit (copie de l'app Overcut Perso, textes et styles du thème).
   Photo de la voiture -> illustration (Gemini, style Overcut) -> aperçu brodé au cœur, puis propriétés de ligne de panier.
   Le bloc lit la couleur (French marine, Écru, Kaki) dans les options de la variante choisie. */
(function () {
  'use strict';

  var FABRIC_WORDS = [
    ['marine', /marine|navy|bleu/i], ['ecru', /écru|ecru|cream|crème|creme|naturel/i], ['kaki', /kaki|khaki|vert/i]
  ];
  var FABRIC_HEX = { marine: '#1F2A44', ecru: '#ECE6DA', kaki: '#6B6A4B' };

  // Animation d'attente : une aiguille brode la silhouette d'une voiture en point avant.
  var CAR = 'M20 78 L22 62 L40 56 L88 50 L112 28 L130 24 L178 24 L198 30 L222 50 L246 56 L250 66 L248 80 L230 80 '
    + 'A20 20 0 0 0 190 80 L86 80 A20 20 0 0 0 46 80 Z M50 80 a16 16 0 1 0 32 0 a16 16 0 1 0 -32 0 '
    + 'M194 80 a16 16 0 1 0 32 0 a16 16 0 1 0 -32 0 M118 48 L134 30 L160 30 L160 48 Z M166 48 L166 30 L180 30 L196 48 Z';
  // La barre avance d'elle-même (courbe qui ralentit) entre deux bornes, les messages suivent l'étape.
  var PHASES = {
    dessin: { from: 4, to: 62, tau: 14000, every: 4500,
      msgs: ['Nous regardons votre voiture', 'Nous traçons la silhouette', 'Nous posons les aplats de couleur', 'Nous simplifions les détails pour 5 cm', 'Nous terminons le dessin'] },
    broderie: { from: 62, to: 97, tau: 4000, every: 2500,
      msgs: ['Nous choisissons les fils', 'La machine brode votre aperçu', 'Dernières finitions'] }
  };
  // image transparente : une case vide montre le motif d'attente, pas l'icône d'image cassée
  var VIDE = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  var loaders = 0;

  // Identifiant aléatoire de l'appareil, gardé dans le navigateur : le quota de
  // 3 aperçus par jour se compte par appareil, pas par adresse IP (les réseaux
  // mobiles font partager une IP à beaucoup d'abonnés). Rien de personnel.
  function appareil() {
    var cle = 'overcut:appareil', id = '';
    try { id = localStorage.getItem(cle) || ''; } catch (e) {}
    if (!/^[A-Za-z0-9-]{16,64}$/.test(id)) {
      id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
        : 'a' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
      try { localStorage.setItem(cle, id); } catch (e) {}
    }
    return id;
  }

  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'class') n.className = attrs[k];
      else n.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }

  function resizeImage(file, max) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      var url = URL.createObjectURL(file);
      img.onload = function () {
        var s = Math.min(1, max / Math.max(img.width, img.height));
        var c = document.createElement('canvas');
        c.width = Math.round(img.width * s); c.height = Math.round(img.height * s);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        c.toBlob(function (b) { b ? resolve(b) : reject(new Error('conversion')); }, 'image/jpeg', 0.9);
      };
      img.onerror = function () { reject(new Error('Image illisible')); };
      img.src = url;
    });
  }

  function init(root) {
    var api = (root.getAttribute('data-api') || '').replace(/\/$/, '');
    var product = {};
    try { product = JSON.parse(root.querySelector('script[data-oc-product]').textContent); } catch (e) {}
    // Le bon formulaire est celui qui porte le bouton d'achat : on écarte celui
    // des paiements en plusieurs fois (classe payment-terms, placé avant dans la
    // page sur Horizon) et ceux des fenêtres d'ajout rapide.
    var forms = Array.prototype.filter.call(document.querySelectorAll('form[action*="/cart/add"]'), function (f) {
      return !f.classList.contains('payment-terms') && !f.closest('dialog, quick-add-component, overcut-quick-add-sheet');
    });
    var form = forms.filter(function (f) { return f.querySelector('[type="submit"], [name="add"]'); })[0] || forms[0];
    if (!form) { root.textContent = 'Formulaire produit introuvable.'; return; }

    var state = { id: null, placement: null, apercu: null, illustration: null, busy: false };

    // --- lecture de la variante choisie -------------------------------------------------
    function currentVariant() {
      var idInput = form.querySelector('[name="id"]');
      var vid = idInput ? String(idInput.value) : '';
      return (product.variants || []).filter(function (v) { return String(v.id) === vid; })[0] || (product.variants || [])[0];
    }
    function optionValue(re) {
      var v = currentVariant(); if (!v) return '';
      for (var i = 0; i < (product.options || []).length; i++) {
        var name = typeof product.options[i] === 'string' ? product.options[i] : product.options[i].name;
        if (re.test(name)) return v.options[i] || '';
      }
      return '';
    }
    function placement() { return 'coeur'; }  // Overcut : broderie au cœur uniquement
    function fabric() {
      var v = optionValue(/^(couleur|color|coloris|colour)$/i) || optionValue(/couleur|color|coloris|colour/i);
      for (var i = 0; i < FABRIC_WORDS.length; i++) if (FABRIC_WORDS[i][1].test(v)) return FABRIC_WORDS[i][0];
      return 'marine';
    }

    // --- interface ---------------------------------------------------------------------
    var fileInput = el('input', { type: 'file', accept: 'image/jpeg,image/png,image/webp,image/heic', class: 'oc-file', id: 'oc-file' });
    var drop = el('label', { class: 'oc-drop', for: 'oc-file' }, [
      el('span', { class: 'oc-drop-title', text: 'Envoyer la photo de votre voiture' }),
      el('span', { class: 'oc-muted', text: 'Vue de trois quarts avant, voiture entière, en plein jour. Trois essais par jour.' })
    ]);
    var status = el('div', { class: 'oc-status', role: 'status', 'aria-live': 'polite' });
    var bar = el('div', { class: 'oc-bar' }, [el('div', { class: 'oc-bar-fill' })]);
    var loaderMsg = el('p', { class: 'oc-loader-msg', role: 'status', 'aria-live': 'polite' });
    var loader = el('div', { class: 'oc-loader', hidden: 'hidden' }, [loaderMsg, bar]);
    var maskId = 'oc-reveal-' + (++loaders);
    loader.insertAdjacentHTML('afterbegin', '<svg viewBox="0 0 270 110" aria-hidden="true" focusable="false">'
      + '<defs><mask id="' + maskId + '"><path class="oc-reveal" d="' + CAR + '" pathLength="100"/></mask></defs>'
      + '<path class="oc-fill" d="' + CAR + '" fill-rule="evenodd"/>'
      + '<path class="oc-guide" d="' + CAR + '"/>'
      + '<path class="oc-stitch" d="' + CAR + '" mask="url(#' + maskId + ')"/>'
      + '<circle class="oc-needle" r="3.2"><animateMotion dur="3.2s" repeatCount="indefinite" path="' + CAR.split(' Z')[0] + ' Z"/></circle>'
      + '</svg>');
    var imgPhoto = el('img', { alt: 'Votre photo' });
    var imgIll = el('img', { alt: 'Illustration de votre voiture' });
    var imgBrod = el('img', { alt: 'Aperçu brodé' });
    function fig(img, cap) { return el('figure', { class: 'oc-fig' }, [img, el('figcaption', { text: cap })]); }
    var grid = el('div', { class: 'oc-grid', hidden: 'hidden' }, [fig(imgPhoto, 'Votre photo'), fig(imgIll, 'Illustration'), fig(imgBrod, 'Rendu broderie')]);
    var stats = el('p', { class: 'oc-muted oc-stats' });
    var note = el('p', { class: 'oc-note', text: 'Le rendu au fil peut légèrement varier : relief, nuances, détails de moins de 1 mm.' });
    var retry = el('button', { type: 'button', class: 'oc-link', text: 'Essayer une autre photo' });
    // Pas de case à cocher : l'ajout au panier vaut validation de l'aperçu. La phrase
    // informe avant l'achat de l'absence de rétractation (art. L221-28, 3° du Code de la consommation).
    var mention = el('p', { class: 'oc-mention', text: "En ajoutant au panier, vous validez cet aperçu. Pièce faite pour vous à partir de votre photo : ni reprise ni échange." });
    var result = el('div', { class: 'oc-result', hidden: 'hidden' }, [stats, note, retry, mention]);

    root.appendChild(el('div', { class: 'oc-card' }, [
      el('p', { class: 'oc-step', text: 'Votre voiture, brodée au cœur' }),
      fileInput, drop, loader, status, grid, result
    ]));
    [imgPhoto, imgIll, imgBrod].forEach(function (img) { setImg(img, null); });

    // --- propriétés de ligne et blocage du panier -------------------------------------
    function setProp(key, value) {
      var input = form.querySelector('input[data-oc="' + key + '"]');
      if (!input) { input = el('input', { type: 'hidden', 'data-oc': key, name: 'properties[' + key + ']' }); form.appendChild(input); }
      input.value = value || '';
      input.disabled = !value;
    }
    function ready() { return !!(state.id && state.apercu && state.placement === placement()); }
    function sync() {
      setProp('_oc_id', ready() ? state.id : '');
      setProp('_oc_placement', ready() ? state.placement : '');
      setProp('Aperçu', ready() ? state.apercu : '');
      var lock = !ready();
      form.querySelectorAll('[type="submit"], [name="add"]').forEach(function (b) {
        if (b.disabled !== lock) b.disabled = lock;          // n'écrit que si ça change (évite les boucles)
        if (b.getAttribute('aria-disabled') !== String(lock)) b.setAttribute('aria-disabled', String(lock));
      });
    }
    // capture au niveau du document : passe avant les gestionnaires du thème (Horizon, Dawn...)
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (!ready()) {
        e.preventDefault(); e.stopImmediatePropagation();
        say(state.id ? "Patientez, l'aperçu de votre broderie arrive." : "Envoyez la photo de votre voiture pour voir l'aperçu.", true);
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);
    function onVariantChange() {
      if (state.id && state.placement !== placement()) {
        say("Renvoyez votre photo pour recalculer l'aperçu.", true);
        reset(false);
      } else if (state.apercu) {
        imgBrod.style.background = FABRIC_HEX[fabric()];
      }
      sync();
    }
    // le sélecteur de variante peut être hors du formulaire : on surveille l'id de variante
    var lastVariant = (form.querySelector('[name="id"]') || {}).value;
    setInterval(function () {
      var v = (form.querySelector('[name="id"]') || {}).value;
      if (v !== lastVariant) { lastVariant = v; onVariantChange(); }
    }, 400);
    document.addEventListener('change', function (e) { if (form.contains(e.target)) onVariantChange(); });
    // le thème peut réactiver le bouton après un changement de variante
    new MutationObserver(function () {
      if (ready()) return;
      var reopened = Array.prototype.some.call(form.querySelectorAll('[type="submit"], [name="add"]'), function (b) { return !b.disabled; });
      if (reopened) sync();
    }).observe(form, { subtree: true, attributes: true, attributeFilter: ['disabled'] });

    function say(msg, warn) { status.textContent = msg; status.className = 'oc-status' + (warn ? ' oc-warn' : ''); }
    function setImg(img, src) {
      img.src = src || VIDE;
      if (src) img.removeAttribute('data-vide'); else img.setAttribute('data-vide', '');
    }
    // Sur téléphone, le retour de la galerie photo laisse souvent la page
    // ailleurs : on ramène le visiteur sur l'animation, puis sur l'aperçu prêt,
    // seulement s'ils sont hors de l'écran.
    var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function montrer(node) {
      var r = node.getBoundingClientRect();
      if (r.top >= 0 && r.bottom <= window.innerHeight) return;
      node.scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'center' });
    }
    var anim = { timer: null, msgTimer: null, shown: 0 };
    function phase(name) {
      clearInterval(anim.timer); clearInterval(anim.msgTimer);
      if (!name) { loader.hidden = true; delete loader.dataset.phase; anim.shown = 0; bar.firstChild.style.width = '0'; return; }
      var ph = PHASES[name], t0 = Date.now(), i = 0;
      loader.hidden = false; loader.dataset.phase = name; say('');
      anim.shown = Math.max(anim.shown, ph.from);
      loaderMsg.textContent = ph.msgs[0];
      anim.timer = setInterval(function () {
        anim.shown = Math.max(anim.shown, ph.from + (ph.to - ph.from) * (1 - Math.exp(-(Date.now() - t0) / ph.tau)));
        bar.firstChild.style.width = anim.shown.toFixed(1) + '%';
      }, 150);
      anim.msgTimer = setInterval(function () { i = Math.min(i + 1, ph.msgs.length - 1); loaderMsg.textContent = ph.msgs[i]; }, ph.every);
    }
    function reset(clearFile) {
      state = { id: null, placement: null, apercu: null, illustration: null, busy: false };
      grid.hidden = true; result.hidden = true; phase(null);
      if (clearFile) fileInput.value = '';
      drop.hidden = false; sync();
    }
    retry.addEventListener('click', function () { reset(true); say(''); fileInput.click(); });

    async function call(path, opts) {
      var r = await fetch(api + path, opts);
      var data = {};
      try { data = await r.json(); } catch (e) {}
      if (!r.ok) throw new Error(data.detail || ('Erreur ' + r.status));
      return data;
    }

    fileInput.addEventListener('change', async function () {
      var file = fileInput.files && fileInput.files[0];
      if (!file || state.busy) return;
      reset(false); state.busy = true; drop.hidden = true;
      var pl = placement();
      try {
        var small = await resizeImage(file, 1600);
        setImg(imgPhoto, URL.createObjectURL(small));
        phase('dessin');
        requestAnimationFrame(function () { montrer(loader); });
        var fd = new FormData(); fd.append('photo', small, 'photo.jpg'); fd.append('placement', pl); fd.append('appareil', appareil());
        var p = await call('/api/preview', { method: 'POST', body: fd });
        state.id = p.id; state.placement = pl; state.illustration = p.illustration; state.restants = p.restants;
        setImg(imgIll, p.illustration); setImg(imgBrod, null);
        grid.hidden = false; phase('broderie');
        var s = await call('/api/stitch', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: p.id, placement: pl, fabric: fabric() }) });
        state.apercu = s.apercu; setImg(imgBrod, s.apercu); imgBrod.style.background = FABRIC_HEX[fabric()];
        stats.textContent = 'Au cœur, ' + Math.round(Math.max.apply(null, s.taille_mm)) + ' mm, ' + s.fils + ' couleurs de fil, environ ' + (Math.round(s.points / 1000) * 1000).toLocaleString('fr-FR') + ' points';
        result.hidden = false; phase(null);
        requestAnimationFrame(function () { montrer(grid); });
        say('Votre aperçu est prêt : vous pouvez l\'ajouter au panier.');
        if (typeof state.restants === 'number') {
          retry.textContent = state.restants > 0
            ? 'Essayer une autre photo (' + state.restants + (state.restants > 1 ? ' essais restants' : ' essai restant') + " aujourd'hui)"
            : "Plus d'essai aujourd'hui, revenez demain pour une autre photo";
          retry.disabled = state.restants <= 0;
        }
      } catch (err) {
        phase(null); drop.hidden = false;
        say((err && err.message) || "Une erreur est survenue, réessayez.", true);
      } finally {
        state.busy = false; sync();
      }
    });
    sync();
  }

  function boot() { document.querySelectorAll('.oc-perso[data-api]').forEach(function (r) { if (!r.dataset.ocReady) { r.dataset.ocReady = '1'; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
